import core, { View } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { SetState, SportEventMetaKey } from 'app-constants';
import { useMemoSelector } from 'hooks';

const {
    entities: {
        selectors: { selectMatchMeta },
    },
} = core;

interface Input {
    text: string | null;
    sportEvent: View.Match;
}

interface Output {
    text: string | null;
}

export default function useFixtureDataTennis({
    text,
    sportEvent,
}: Input): Output {
    const { meta } = useMemoSelector(makeSelectProps(), {
        matchId: sportEvent.id,
    });

    const setState = meta.find(
        ({ name }) => name === SportEventMetaKey.SetState
    );

    return {
        text: setState?.value === SetState.TieBreak ? 'Tie-Break' : text,
    };
}

const makeSelectProps = () =>
    createStructuredSelector({
        meta: selectMatchMeta,
    });
